<template>
    <div id="viewerContainer">
    </div>
</template>
<style>
    #viewerContainer {
        background-color: #e5e5e5;
        height: 109vh;
    }
</style>
<script lang="js">
import Vue from "vue";
import { env } from '@/environment/environment';
import { api } from '@/services/api';
import "@grapecity/ar-viewer/dist/jsViewer.min.js";
import "@grapecity/ar-viewer/dist/jsViewer.min.css";

export default Vue.extend({
  name: "Viewer",
  props: ['reportName', 'dataUrl', 'reportParams', 'printOnly'],        
  data: function() {
    return {
        viewer: {},
        reportToken: null,
    };
  },
  methods: {
    apiUrl: function() {
      return env.VUE_APP_API_URL.replace(/\/+$/, '');
    },
    printReport: function() {
      this.viewer.print();
    },
    exportToCsv: function() {
      this.viewer.export('csv', null, true, {PrintOnOpen: 'true'});
    },
    exportToPdf: function(fileName) { 
      this.viewer.export('pdf', function (uri) {
                var newWin = null;
                try {
                    newWin = window.open(uri);
                } catch (e) {
                    // Some browsers reject popups; same-window navigation below is the fallback.
                }
                if (!newWin) {
                    window.location = uri;
                }},
                false, 
                { FileName: `${fileName}.pdf` }
          );
    },
    handleViewerError: function(error) {
      if (error.severity && error.severity !== 'error') return false;

      const message = [error.message, error.details].filter(Boolean).join(': ');
      const viewerError = new Error(message || 'ActiveReports viewer error');
      viewerError.name = 'ActiveReportsError';
      this.$handleError(viewerError);
      return true;
    },
    openReport: function () {
      if(this.printOnly) {
        this.viewer.sidebar.toggle(false);
      }

      const separator = this.dataUrl.includes('?') ? '&' : '?';
      let params = [
          { name: 'API_URL', values: [`${this.apiUrl()}${this.dataUrl}${separator}reportToken=${encodeURIComponent(this.reportToken)}`]},
        ];


      if(this.reportParams){
        params = params.concat(this.reportParams);
      }    
      this.viewer.openReport(
        this.reportName,
        params
      );
    }    
  },
  async mounted() {
          const { data } = await api.post('/reports/access-token');
          this.reportToken = data.token;
          const userToken = localStorage.getItem('userToken');
          this.viewer = new GrapeCity.ActiveReports.JSViewer.create({                
            element: '#viewerContainer',
            availableExports: ["pdf", "html", "tabular-data"],
            reportService: {
              url: `${this.apiUrl()}/api/reporting`,
              onRequest: (init) => {
                init.credentials = 'omit';
                const headers = new Headers(init.headers);
                headers.set('Authorization', `Bearer ${userToken}`);
                init.headers = headers;
              }
            },
            error: this.handleViewerError,
          });
          
          this.openReport();
  },
  watch: {
    reportName() {
      const userToken = localStorage.getItem('userToken');
      this.viewer = new GrapeCity.ActiveReports.JSViewer.create({                
            element: '#viewerContainer',
            availableExports: ["pdf"],
            reportService: {
              url: `${this.apiUrl()}/api/reporting`,
              onRequest: (init) => {
                init.credentials = 'omit';
                const headers = new Headers(init.headers);
                headers.set('Authorization', `Bearer ${userToken}`);
                init.headers = headers;
              }
            },
            error: this.handleViewerError,
          });
      this.openReport();
    },            
    dataUrl() {
      this.openReport();
    },            
    reportParams() {
      this.openReport();
    },    
  },  
});
</script>
